import axios from "axios";
import { loginRefresh } from "./protectedClientHelper";

const protectedClient = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_API_BASE_URI,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

protectedClient.interceptors.request.use(
  async (config) => {
    // Skip token check for login and authorization endpoints
    if (
      config.url !== "/api/identity/login/passcode" &&
      config.url !== config.baseURL + "/api/identity/login/passcode" &&
      config.url !== "/api/identity/authorized" &&
      config.url !== config.baseURL + "/api/identity/authorized"
    ) {
      const tokenExpireAtString = localStorage.getItem("tokenExpireAt");
      const currentTime = new Date().getTime();

      // If tokenExpireAt is null or empty, clear storage and redirect to login
      if (tokenExpireAtString !== null && !tokenExpireAtString) {
        localStorage.removeItem("tokenExpireAt");
        localStorage.removeItem("refreshTokenExpireAt");
        localStorage.removeItem("phoneNumber");
        window.location.href = "/login";
        return;
      }
      const tokenExpireAt = new Date(tokenExpireAtString);
      // If token is expired
      if (tokenExpireAt && currentTime > tokenExpireAt.getTime()) {
        const refreshTokenExpireAtString = localStorage.getItem(
          "refreshTokenExpireAt"
        );
        // No refresh token available
        if (!refreshTokenExpireAtString) {
          console.log("No refresh token available")
          localStorage.removeItem("tokenExpireAt");
          localStorage.removeItem("refreshTokenExpireAt");
          localStorage.removeItem("phoneNumber");
          window.location.href = "/login";
          return;
        }

        const refreshTokenExpireAt = new Date(refreshTokenExpireAtString);
        // Refresh token also expired
        if (
          refreshTokenExpireAt &&
          currentTime > refreshTokenExpireAt.getTime()
        ) {
          console.log("Refresh expired")
          localStorage.removeItem("tokenExpireAt");
          localStorage.removeItem("refreshTokenExpireAt");
          localStorage.removeItem("phoneNumber");
          window.location.href = "/login";
          return;
        } else {
          await loginRefresh();
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default protectedClient;
